const actionType = {
    GET_BLOCDATAEXPLORER_RECORDS_SUCCESS: 'GET_BLOCDATAEXPLORER_RECORDS_SUCCESS',
    GET_SOURCEDATAEXPLORER_RECORDS_SUCCESS: 'GET_SOURCEDATAEXPLORER_RECORDS_SUCCESS',
    GET_BLOCDATAEXPLORER_RECORDS_FAILURE: 'GET_BLOCDATAEXPLORER_RECORDS_FAILURE',
    GET_SOURCEDATAEXPLORER_RECORDS_FAILURE: 'GET_SOURCEDATAEXPLORER_RECORDS_FAILURE',
    GET_ALL_BLOCDATAEXPLORER_NAMES_SUCCESS: 'GET_ALL_BLOCDATAEXPLORER_NAMES_SUCCESS',
    GET_ALL_BLOCDATAEXPLORER_NAMES_FAILURE: 'GET_ALL_BLOCDATAEXPLORER_NAMES_FAILURE',
    GET_ALL_REFDATAGOLDENEXPLORER_NAMES_SUCCESS: 'GET_ALL_REFDATAGOLDENEXPLORER_NAMES_SUCCESS',
    GET_REFDATAGOLDENEXPLORER_RECORDS_SUCCESS: 'GET_REFDATAGOLDENEXPLORER_RECORDS_SUCCESS',
    GET_REFDATAGOLDENEXPLORER_RECORDS_BY_ID_SUCCESS: 'GET_REFDATAGOLDENEXPLORER_RECORDS_BY_ID_SUCCESS',
    GET_SOURCE_SUMMARY_DATA: 'GET_SOURCE_SUMMARY_DATA',
    GET_GROUP_HISTORY_DATA: 'GET_GROUP_HISTORY_DATA',
    GET_GROUP_LINEAGE_DATA: 'GET_GROUP_LINEAGE_DATA',
    ADD_API_LOGGERS: 'ADD_API_LOGGERS',
    GET_LINKED_RECORDS: 'GET_LINKED_RECORDS',
    GET_GROUP_GC_ID: 'GET_GROUP_GC_ID',
    GET_SOURCE_DATA_RECORDS_SUCCESS: 'GET_SOURCE_DATA_RECORDS_SUCCESS',
    GET_SOURCE_DATA_CONTRIBUTION_SUCCESS: 'GET_SOURCE_DATA_CONTRIBUTION_SUCCESS',
    GET_GC_HISTORIC_DATA: 'GET_GC_HISTORIC_DATA',
    GET_LINKED_GROUPS: 'GET_LINKED_GROUPS',
    GET_REF_DATA_LINKED_GROUP_RECORDS: 'GET_REF_DATA_LINKED_GROUP_RECORDS',
    CLEAN_LINKED_GROUPS: 'CLEAN_LINKED_GROUPS',
    GET_GC_PREVIOUS_DATA: 'GET_GC_PREVIOUS_DATA',
    GET_LINKED_DD_DATA: 'GET_LINKED_DD_DATA',
    GET_TRADES_CHARTS_DATA: 'GET_TRADES_CHARTS_DATA',
    GET_RECORDS_FOR_AUTHORIZATION: 'GET_RECORDS_FOR_AUTHORIZATION',
};
export default actionType;
